<template>
	<div class="col-12 px-0">
		<div class="col-12 px-0">
			<div class="table-responsive" v-if="headers.length > 0"
					:style="max_height ? `max-height: ${max_height}` : ''"
					@scroll.capture="ScrollEvent"
					ref=table>
				<table class="table table-custom font-14">
					<thead>
						<tr>
							<th v-if="checkbox">
								<div class="form-check">
									<input 
										type="checkbox" 
										id="checkbox-all"
										v-model="check_all"
									>
									<label for="checkbox-all"></label>
								</div>
							</th>
							<th 
								v-for="(header,index) in headers" 
								:key="index"
								class="text-muted"
								
								:class="{
									'text-center': 	header.align == 'center',
									'text-left': 	header.align == 'left',
									'text-right': 	header.align == 'right',
									'sortable': 	header.value && header.sortable,
									'active': 		sortedBy.column == header.value
								}"
								@click="SortData(header)"
							>
								<div class="th-content"
									:class="header.align == 'center' ? 'd-flex justify-content-center' : ''">
									{{header.text}} 
									<div class="sort-icon">
										<i :class="`far ${sortedBy.icon}`" v-if="sortedBy.column == header.value"/>
									</div>
								</div>
							</th>
						</tr>
					</thead>
					<transition 
						name="fast-fade" 
						mode="out-in"
					>
						<tbody v-if="filtered_items.length > 0">
							<tr 
								v-for="(item,index) in filtered_items"
								:class="`${ trButton ? 'tr-btn' : '' } ${row_color ? item.row_color : ''}`"	
								:key="index * Math.random()"
								@click="ByClickOnTR(item)"
							>
								<td v-if="checkbox" scope="col">
									<div class="form-check">
										<input 
											type="checkbox" 
											:id="`checkbox-${index}`"
											:value="item[checkbox_value]"
											v-model="selected_checkboxes"
											@change="EmitCheckboxes"
										>
										<label :for="`checkbox-${index}`"></label>
									</div>
								</td>
								<slot name="body" :item="item" :index="index"></slot>
							</tr>
						</tbody>
						<tbody 
							v-else-if="filtered_items.length < 1 && items.length > 0"
							key="empty"
						>
							<tr>
								<td :colspan="headers.length">
									<slot name="no-match" >
										<div class="custom-alert-warning">	
											<b>Sua pesquisa por "{{ search }}" retornou sem resultados.</b>
										</div>
									</slot>
								</td>
							</tr>
						</tbody>
						<tbody 
							v-else
							key="no-data"
						>
							<tr>
								<td :colspan="checkbox ? headers.length + 1 : headers.length">
									<slot name="no-data">
										<div class="custom-alert-info">						
											<b>Não há registros para exibir.</b>
										</div>
									</slot>
								</td>
							</tr>
						</tbody>
					</transition>
					<tfoot v-if="items.length > 0">
						<tr>
							<slot name="footer" :items="items"></slot>
						</tr>
					</tfoot>
				</table>
			</div>
		</div>
		<div class="col-12 col-md-auto text-center text-md-right mt-3 align-self-center counter" v-if="items.length > 0">
			<span>
				{{paginate ? 
					`De ${paginateSetup.init_item} até ${paginateSetup.end_item} de ${items.length} itens` : 
					`Total: ${scrollUpdate ? filtered_items.length : items.length} itens`}}
			</span>
		</div>
		<div class="col-12 col-md text-center text-md-right mt-3 align-self-center" v-if="paginate">
			<div class="btn-group btn-group-sm">
				<button
					type="button"
					class="btn btn-primary"
					:disabled="paginateSetup.page === 1"
					@click="WalkPaginate('prev')"
				>
					Anterior
				</button>
				<button 
					type="button"
					class="btn btn-primary"
					disabled
				>
					{{ paginateSetup.page }}
				</button>
				<button
					type="button"
					class="btn btn-primary"
					:disabled="paginateSetup.page === paginateSetup.total_pages || filtered_items.length < 1"
					@click="WalkPaginate('next')"
				>
					Próximo
				</button>
			</div>
		</div>
	</div>
</template>

<script>
	import Helpers from '../../helpers'

	const _ = require('lodash')
	
	const helpers 		= new Helpers()

	export default {

		name: 'DataTables',
		props: {
			value: 			{
				type: 			Array,
				required: 		false,
				default: 		() => []
			},
			headers: 		{
				type: 			Array,
				required: 		true,
				default: 		() => []
			},
			search: 		{
				type: 			String,
				required: 		false,
				default: 		''
			},
			paginate: 		{
				type: 			Boolean,
				required: 		false,
				default: 		false
			},
			itemsPerPage: 	{
				type: 			Number,
				required: 		false,
				default: 		10
			},
			trButton: 		{
				type: 			Boolean,
				required: 		false,
				default: 		false
			},
			checkbox: 		{
				type: 			Boolean,
				default: 		false
			},
			row_color: 		{
				type: 			Boolean,
				default: 		false
			},
			checkbox_value: {
				type: 			String,
				default: 		'id'
			},
			max_height: 	{
				type:			String,
				required:		false,
				default:		null
			},
			scrollUpdate:	{
				type:			Boolean,
				required:		false,
				default:		false
			}
		},
		data () {
			return {
				currentPage: 			1,
				items: 					[],
				items_limiteds: 		[],
				sortedBy: 				{
					column: 				'',
					direction: 				'',
					icon: 					''
				},
				paginateSetup: 			{
				  	page: 					null,
				  	per_page: 				null,
				  	pre_page: 				null,
				  	next_page: 				null,
				  	total: 					null,
				  	total_pages: 			null,
				  	data: 				[]
				},
				selected_checkboxes: 	[],
				check_all: 				false,
				limit:					50
			}
		},
		computed: {
			filtered_items() {
				//BUSCA
				let items = this.items.filter( item => {
					let search = helpers.SanitizedDocument(helpers.RemoveAcento(this.search)).toString().toLowerCase().trim()
					let match = false

					this.headers.map(header => {
						if(header.value && window._.get(item, header.value)) {
							let i = helpers.SanitizedDocument(helpers.RemoveAcento(window._.get(item, header.value))).toString().toLowerCase().trim()

							if(i.indexOf(search) > -1) {
								match 		= true
							}
						}
					})

					return this.search && this.headers.length > 0 ? match : true
				})

				//ORDENAÇÃO
				if(!this.fetchSort) {
					this.headers.map(header => {
						if(header.value == this.sortedBy.column) {
							items.sort(this.OrderItems(header.value, this.sortedBy.direction))
						}
					})
				}

				//PAGINATION
				if(this.paginate) {
					let itemsPerPage = this.itemsPerPage ? this.itemsPerPage : 5

					let numberOfPages = Math.ceil(items.length / itemsPerPage)

					let paginate = this.Paginate(items, this.currentPage, itemsPerPage)

					items = paginate.data
					this.paginateSetup = paginate
				}

				return items
			}
		},
		watch: {
			value: {
				immediate: true,
				handler(val)
				{
					this.items 					= val
					this.selected_checkboxes 	= []
					this.check_all 				= false
				},
				deep: true
			},
			check_all: {
				handler(val)
				{
					if(val)
					{
						this.items.forEach( item => {
							this.selected_checkboxes.push(item[this.checkbox_value])
						})

					}else{

						this.selected_checkboxes 		= []

					}

					this.EmitCheckboxes()
				}
			}
		},
		methods: {
			EmitCheckboxes()
			{
				this.$emit('checkeds', this.selected_checkboxes)
			},
			ByClickOnTR(item)
			{
				if(this.trButton)
				{
					this.$emit('by-click-on-tr', item)
				}
			},
			OrderItems(key, order = 'ASC') 
			{
				return function InnerSort(a, b) 
				{
					if(typeof window._.get(a, key) === 'boolean' || typeof window._.get(b, key) === 'boolean')
					{
						if(window._.get(a, key) && !window._.get(b, key))
						{
							return (order === 'DESC') ? 1 : -1

						}else if(!window._.get(a, key) && window._.get(b, key))
						{
							return (order === 'DESC') ? -1 : 1
						}

						return 0
					}

					if (!window._.get(a, key) || !window._.get(b, key)) 
					{
						return 0
					}

					const varA 		= (typeof window._.get(a, key) === 'string') ? window._.get(a, key).toUpperCase() : window._.get(a, key)

					const varB 		= (typeof window._.get(b, key) === 'string') ? window._.get(b, key).toUpperCase() : window._.get(b, key)

					let comparison 	= 0
					
					if (varA > varB) 
					{
						comparison 		= 1

					} else if (varA < varB) 
					{
						comparison 		= -1
					}

					return (
						(order === 'DESC') ? (comparison * -1) : comparison
					)
				}
			},
			Paginate( items, page = 1, per_page = 5) 
			{
			    page 				= page || 1
				per_page 			= per_page || 5
			  	let offset 			= (page - 1) * per_page
				let paginatedItems 	= items.slice(offset).slice(0, per_page)
				let total_pages 	= Math.ceil(items.length / per_page)

				return {
				  	page: 			page,
				  	per_page: 		per_page,
				  	init_item: 		(offset + 1),
				  	end_item: 		(offset + paginatedItems.length),
				  	pre_page: 		page - 1 ? page - 1 : null,
				  	next_page: 		(total_pages > page) ? page + 1 : null,
				  	total: 			items.length,
				  	total_pages: 	total_pages,
				  	data: 			paginatedItems
			  	}
			},
			WalkPaginate(mode)
			{
				switch(mode)
				{
					case 'prev':
						this.currentPage 	= this.currentPage <= 1 ? 1 : this.currentPage - 1
					break;
					case 'next':
						this.currentPage 	= this.currentPage < this.paginateSetup.total_pages ? this.currentPage + 1 : this.currentPage - this.paginateSetup.total_pages
					break;
				}
			},
			SortData(header)
			{
				if(header.value && header.sortable)
				{
					if(this.sortedBy.column != header.value)
					{
						this.sortedBy.column 	= header.value
						this.sortedBy.direction = ''
						this.sortedBy.icon 		= ''
					}

					let items 		= [...this.items]

					switch(this.sortedBy.direction)
					{
						case 'ASC':
							this.sortedBy.direction 	= 'DESC'
							this.sortedBy.icon 			= 'fa-chevron-down'

							items.sort(this.OrderItems(header.value, 'DESC'))

							this.items 		= [...items]

						break;
						case 'DESC':

							this.sortedBy.column 		= ''
							this.sortedBy.direction 	= ''
							this.sortedBy.icon 			= ''

							items.sort(this.OrderItems(this.headers[0].value, 'ASC'))

							this.items 		= [...items]

						break;
						default: 
							this.sortedBy.direction 	= 'ASC'
							this.sortedBy.icon 			= 'fa-chevron-up'

							items.sort(this.OrderItems(header.value, 'ASC'))

							this.items 		= [...items]

						break;
					}
				}
			},
			ScrollEvent(event)
			{
				if(this.scrollUpdate)
				{
					const vm = this
					const table = this.$refs.table
	
					
					let bottomTable = (table.offsetHeight + Math.round(table.scrollTop)) >= table.scrollHeight
	
					if (bottomTable) {
						vm.limit += vm.limit

						vm.$emit('load-table', vm.limit)
					}
				}
			}
		}
	}
</script>

<style lang="css" scoped>
	table.table-custom .th-content
	{
		display: flex;
		flex-direction: row;
	}

	table.table-custom .th-content .sort-icon
	{
		margin: 0 5px;
	}

	table.table-custom .header-sticky
	{
		position: sticky;
	}

	table
	{
		min-width: 700px;
	}
</style>